import { Expose, Transform } from "class-transformer";
import { PointPricePositionEnum } from "@altertec_gparn/lib";
import { toCents, toMinutes } from "@/utils/numberUtils";

export class UpdateUserHiringDataDto {
  @Expose()
  @Transform(({ value }) => toCents(value))
  payrollHourlyRate?: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  payrollHolidayHourlyRate?: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  payrollExtraHourlyRate?: number;

  @Expose()
  @Transform(({ value }) => toMinutes(value))
  dailyMinutes?: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  teamLeadDailyRate?: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  abroadWorkGeneralDailyRate?: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  abroadWorkTeamLeaderDailyRate?: number;

  @Expose()
  pointPricePosition?: PointPricePositionEnum | null;

  @Expose()
  isProductivityApplicable?: boolean;
}
